import React from "react";
import ReactDOM from "react-dom";
import ApproveRentingModal from "./index";

export default async function renderApproveRentingModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<ApproveRentingModal {...rest} />, domTarget);
  }
}
